module.exports = __webpack_public_path__ + "static/media/MR.cb629791.svg";